(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["looping-media-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('looping-media-section')) {
    class LoopingMediaSection extends HTMLElement {
      connectedCallback() {
        this.videos = Array.from(this.querySelectorAll('video'));
        this.reduce =
          this.dataset.reducedMotion === 'true' &&
          window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.videos.forEach((v) => {
          v.muted = true;
          v.defaultMuted = true;
          v.loop = true;
          v.controls = false;
          v.playsInline = true;
          v.setAttribute('playsinline', '');
          v.setAttribute('aria-hidden', 'true');
          const frame = v.closest('.lms__media-frame');
          v.addEventListener('playing', () => frame && frame.classList.remove('is-paused'));
          if (frame) {
            frame.addEventListener('click', () => {
              if (v.paused) {
                v.dataset.userStarted = 'true';
                this.play(v);
              }
            });
          }
        });

        if (this.reduce) {
          this.videos.forEach((v) => {
            v.removeAttribute('autoplay');
            v.pause();
            const frame = v.closest('.lms__media-frame');
            if (frame) frame.classList.add('is-paused');
          });
        } else if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(
            (entries) => {
              entries.forEach((e) => {
                if (e.isIntersecting) this.play(e.target);
                else e.target.pause();
              });
            },
            { rootMargin: '200px 0px', threshold: 0.01 }
          );
          this.videos.forEach((v) => this.io.observe(v));
        } else {
          this.videos.forEach((v) => this.play(v));
        }

        this.initDots();

        this.onBlockSelect = (e) => {
          if (!this.contains(e.target) || !this.list) return;
          this.scrollToItem(e.target);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.list && this.onScroll) this.list.removeEventListener('scroll', this.onScroll);
        if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      play(v) {
        if (this.reduce && v.dataset.userStarted !== 'true') return;
        if (v.preload === 'none') v.preload = 'auto';
        const p = v.play();
        if (p && typeof p.catch === 'function') {
          p.catch((err) => {
            if (!err || err.name !== 'NotAllowedError') return;
            const frame = v.closest('.lms__media-frame');
            if (frame) frame.classList.add('is-paused');
          });
        }
      }

      scrollToItem(item) {
        if (!this.list || this.list.scrollWidth <= this.list.clientWidth) return;
        const left = item.offsetLeft - (this.list.clientWidth - item.offsetWidth) / 2;
        this.list.scrollTo({ left, behavior: 'smooth' });
      }

      initDots() {
        this.list = this.querySelector('.lms__list');
        const dots = Array.from(this.querySelectorAll('.lms__dot'));
        if (!this.list || !dots.length) return;
        const items = Array.from(this.list.children);

        dots.forEach((dot, i) => {
          dot.addEventListener('click', () => items[i] && this.scrollToItem(items[i]));
        });

        let ticking = false;
        this.onScroll = () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            ticking = false;
            const center = this.list.scrollLeft + this.list.clientWidth / 2;
            let best = 0;
            let bestDist = Infinity;
            items.forEach((item, i) => {
              const d = Math.abs(item.offsetLeft + item.offsetWidth / 2 - center);
              if (d < bestDist) {
                bestDist = d;
                best = i;
              }
            });
            dots.forEach((dot, i) => dot.classList.toggle('is-active', i === best));
          });
        };
        this.list.addEventListener('scroll', this.onScroll, { passive: true });
      }
    }
    customElements.define('looping-media-section', LoopingMediaSection);
  }

  } catch(e) { console.error(e); }
})();
})();
